import { takeEvery, put } from 'redux-saga/effects';
import * as types from './constants';
import { Layout } from '@components/layout'
import {TOASTER_DISPATCH} from '@components/layout/constants';
import { CATALOG_ORDERS } from '~/router/routes';
import {formatMoney} from '~/utils/formatting';

function* rootSagas() {
    yield takeEvery([
        types.EXPORT_ORDERS_REQUEST,
        // types.GET_ORDERS_TABLE_CONFIGURATION_REQUEST,
        types.UPDATE_ORDER_DETAILS_REQUEST,
    ], (Layout.actions.openPreloaderSaga));
    yield takeEvery([
        types.EXPORT_ORDERS_SUCCESS,
        types.EXPORT_ORDERS_FAILURE,
    ], (Layout.actions.closePreloaderSaga));
    yield takeEvery([
        // types.GET_ORDERS_TABLE_CONFIGURATION_SUCCESS,
        // types.GET_ORDERS_TABLE_CONFIGURATION_FAILURE,
        types.UPDATE_ORDER_DETAILS_FAILURE,
        types.UPDATE_ORDER_DETAILS_SUCCESS,
    ], (Layout.actions.closePreloaderSaga));
    yield takeEvery([
        'ws:Order/OrderCreatedNotification',
    ], function* (payload) {
        let {data: {id, order: {company_order_id, amount_total}}} = payload;
        yield put({
            type: TOASTER_DISPATCH,
            notification_id: id,
            toast: {
                type: 'success',
                message: `Создан новый заказ #${company_order_id}. Сумма заказа: ${formatMoney(amount_total)}`,
                link: `${CATALOG_ORDERS}?company_order_id=${company_order_id}`,
            }
        })
    });
    yield takeEvery([
        'ws:Order/OrderUpdatedNotification',
    ], function* (payload) {
        let {data: {order: {company_order_id, amount_total}}} = payload;
        yield put({
            type: TOASTER_DISPATCH,
            toast: {
                type: 'success',
                message: `Заказ #${company_order_id} обновлен. Сумма заказа: ${formatMoney(amount_total)}`,
                link: `${CATALOG_ORDERS}?company_order_id=${company_order_id}`,
            }
        })
    });
}

export default rootSagas;
